import React from 'react';
import { Box, Button, SimpleGrid } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import Container from '../ui/Container';
import SectionHeader from '../ui/SectionHeader';
import ServiceCard from '../ui/ServiceCard';
import { MAIN_SERVICE_GROUPS } from '../../data/services';

export default function FeaturedServices() {
  return (
    <Box as="section" py={{ base: 12, md: 16 }}>
      <Container>
        <SectionHeader
          title="Soluciones eléctricas integrales"
          description="Especialistas en baja y media tensión para la industria, el comercio y la infraestructura."
          action={
            <Button as={RouterLink} to="/services" variant="secondary" display={{ base: 'none', sm: 'inline-flex' }}>
              Ver todos los servicios
            </Button>
          }
        />
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={{ base: 6, lg: 8 }}>
          {MAIN_SERVICE_GROUPS.map(group => (
            <ServiceCard
              key={group.id}
              service={group}
              showHighlights
              ctaTo="/services"
              ctaLabel="Ver servicios"
            />
          ))}
        </SimpleGrid>
        <Box textAlign="center" mt={{ base: 8, md: 10 }}>
          <Button as={RouterLink} to="/services" variant="primary" size="lg">
            Ver todos los servicios
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
